export default "__VITE_PUBLIC_ASSET__89eba39d__"